module.exports = __webpack_public_path__ + "static/media/hanne.d5c63086.jpg";